export const CONSTS = {
  ACCESSORIALS: $localize`Accessorials`,
  HAZMAT: $localize`Hazmat Accessorials`,
  LOCATION_ROLE: $localize`Location Role`,
  LAST_UPDATED_RECORD: $localize`The last updated record was at:`,
  LAST_UPDATED_SWITCH_NOTE: $localize`Please switch to that SLIC to view the most recent information.`,
  DOWNLOAD: $localize`Download`,
};

//NOTE:  ORDER MATTERS HERE!!  VALUES ARE MAPPED 1:1 BASED ON ORDER OF CONST AND INTERFACE
export const TOP_SECTION_ROWS: string[] = [
  $localize`Tracking Number`,
  $localize`ATN`,
  $localize`Service Type Code`,
  $localize`Service Type Mnemonic`,
  $localize`Dimensions (L*W*H)`,
  $localize`Weight`,
  $localize`Weight Unit`,
  $localize`Density`,
];

export interface TopSectionData {
  trackingNo?: string;
  atn?: string;
  serviceCode?: string;
  serviceMnemonic?: string;
  dimensions?: string;
  weight?: string;
  weightUnit?: string;
  density?: string;
}

export const ORIGIN_SECTION_ROWS: string[] = [
  $localize`Shipper Name`,
  $localize`Shipper Number`,
  $localize`Origin Address`,
  $localize`Postal Code`,
  $localize`Country Code`,
  $localize`Origin SLIC`,
  $localize`Pickup Date`,
  $localize`SDD`,
  $localize`RSDD`,
  $localize`RDD`,
];

export interface OriginSectionData {
  shipperName?: string;
  shipperNumber?: string;
  originAddress?: string;
  postalCode?: string;
  countryCode?: string;
  originSlic?: string;
  pickupDate?: string;
  sdd?: string;
  rsdd?: string;
  rdd?: string;
}

export const DEST_SECTION_ROWS: string[] = [
  $localize`Consignee Name`,
  $localize`Consignee Phone`,
  $localize`Delivery Address`,
  $localize`Postal Code`,
  $localize`Country Code`,
  $localize`Destination Hub SLIC`,
  $localize`Consignee Email`,
  $localize`Destination Center SLIC`,
];

export interface DestSectionData {
  consigneeName?: string;
  consigneePhone?: string;
  deliveryAddress?: string;
  postalCode?: string;
  countryCode?: string;
  destHubSlic?: string;
  consigneeEmail?: string;
  destCenterSlic?: string;
}

export const ACCESSORIALS_SECTION_ROWS: string[] = [
  $localize`COD Amount`,
  $localize`COD Currency`,
  $localize`COD Paid`,
  $localize`ICOD Amount`,
  $localize`ICOD Currency`,
  $localize`ICOD Paid`,
  $localize`Package Void`,
  $localize`ADL Eligible`,
  $localize`My Choice Customer`,
  $localize`Signature Required`,
  $localize`Adult Signature Required`,
  $localize`CDI Active`,
  $localize`Intercept Active`,
  $localize`PDI Active`,
  $localize`Info Notice Number 1`,
  $localize`Info Notice Number 2`,
  $localize`Info Notice Number 3`,
  $localize`Accessorials`,
];

export interface AccessorialsSectionData {
  codAmount?: string;
  codCurrency?: string;
  CODIndicator?: string;
  icodAmount?: string;
  icodCurrency?: string;
  ICODIndicator?: string;
  packageVoid?: string;
  adlEligible?: string;
  customerChoice?: string;
  sigRequired?: string;
  adultSigRequired?: string;
  cdiActive?: string;
  interceptActive?: string;
  pdiActive?: string;
  accessorials?: string;
  infoNotice1?: string;
  infoNotice2?: string;
  infoNotice3?: string;
}

export const HAZMAT_SECTION_ROWS: string[] = [
  $localize`Hazmat`,
  $localize`RegQuantityCode`,
  $localize`CA Package`,
  $localize`ADRPackageIndicator`,
  $localize`ADR Points`,
  $localize`Trans Cat 0 Units`,
  $localize`Trans Cat 1 Units`,
  $localize`Trans Cat 2 Units`,
  $localize`Trans Cat 3 Units`,
  $localize`Trans Cat 4 Units`,
];

export interface HazmatSectionData {
  hazmat?: string;
  regQuantity?: string;
  caPackage?: string;
  adrPackageInd?: string;
  adrPoints?: string;
  trans0?: string;
  trans1?: string;
  trans2?: string;
  trans3?: string;
  trans4?: string;
}

export const TIME_SECTION_ROWS: string[] = [
  $localize`Insert Time`,
  $localize`Update Time`,
  $localize`Message Time`,
];

export interface TimeSectionData {
  insertTime?: string;
  updateTime?: string;
  msgTime?: string;
}
////////////////////////////////////////////////////
